<div *ngIf="threadGroupType === 'DEFAULT'" >
<div class="modal-header" >
    <h4 class="modal-title" id="modal-title" style="margin-left:10px;">User Based Load:Load Test Configuration</h4>
    <a type="button" class="close text-white mr-1" (click)="modal.close()">
      <span style="color: black;" aria-hidden="true">&times;</span>
    </a>
  </div>
  <div class="modal-body m-2">
        <h5 class="font-weight-bold">Purpose:</h5>
            <ul class="ml-5" style="font-size:medium;">
                <li>Control the number of stimulated users, ramp-up time, iteration count, and steady state duration.</li>
    </ul>
    <h5 class="font-weight-bold">Example:</h5>
        <ul class="ml-5 mb-2" style="font-size:medium;"><li><b>
            Concurrent Users: </b>10</li>
    <li><b>
        Duration: </b>5 Mins
    </li>
    <li><b>Ramp-Up Time: </b>5 seconds.</li>
    <li><b>Result: </b>10 users will run for 5 mins.</li>
    </ul>
</div>
</div>
<div *ngIf="threadGroupType === 'ULTIMATE'">
        <div class="modal-header">
            <h4 class="modal-title" id="modal-title" style="margin-left:10px;"><b>Custom Load Setup (Ultimate): </b>Load Test Configuration </h4>
            <a type="button" class="close text-white mr-1" (click)="modal.close()">
              <span style="color: black;" aria-hidden="true">&times;</span>
            </a>
          </div>
          <div class="modal-body m-2">

    <h5 class="font-weight-bold">Features:</h5>
    	<ul class="ml-5 mb-2" style="font-size: medium;">
            <li>Customizable load application with control over ramp-up, steady state, and ramp-down.</li>
            <li>Suitable for dynamic ramp-up, spike tests, and step-up tests.</li>
</ul>
	<h5 class="font-weight-bold">Configuration Options:</h5>
    <ul class="ml-5 mb-2" style="font-size: medium;"><li><b>
        Threads schedule table: </b>Sequential execution with parallel option.
    </li>
<li><b>
    Start Threads Count: </b>Users/threads per time slot.
</li>
<li><b>Initial Delay: </b>Time for the first user/thread to hit the server.</li>
<li><b>Ramp-Up Time: </b>Time for all threads to ramp up.</li>
<li><b>Duration: </b>Steady state duration after ramp-up.</li>
<li><b>Ramp Down Time: </b>Interval for killing active threads.</li>
<li><b>Example: </b>Detailed breakdown provided for each time slot with ramp-up, steady state, and ramp-down.</li>
</ul>
</div>
</div>
<div *ngIf="threadGroupType === 'ARRIVAL'">
    <div class="modal-header">
        <h4 class="modal-title" id="modal-title" style="margin-left: 10px;">Request Per Minute (Arrival): Load Test Configuration</h4>
        <a type="button" class="close text-white mr-1" (click)="modal.close()">
          <span style="color: black;" aria-hidden="true">&times;</span>
        </a>
      </div>
      <div class="modal-body m-2">
<h5 class="font-weight-bold">Purpose:</h5>
    <ul class="ml-5 mb-2" style="font-size: medium;">
        <li>Goal-oriented (TPM based) scenarios focusing on request rate.</li>
</ul>
<h5 class="font-weight-bold">Features:</h5>
    <ul class="ml-5 mb-2" style="font-size: medium;">
        <li>Dynamic adjustment of users/threads based on target arrival rate.</li>
</ul>
<h5 class="font-weight-bold">Configuration Options:</h5>
<ul class="ml-5 mb-2" style="font-size: medium;">
<li><b>Target rate: </b>Total requests to start in 1 minute.</li>
<li><b>Ramp-Up Time: </b>Time for users/threads to reach the target arrival rate.</li>
<li><b>Ramp-Up Steps Count: </b>Number of steps for arrival count ramp-up.</li>
<li><b>Duration: </b>Duration for the test to run at steady state.</li>
</ul>
</div>
</div>

<div *ngIf="threadGroupType === 'SET_UP'">
    <div class="modal-header">
        <h4 class="modal-title" id="modal-title" style="margin-left: 10px;">Pre-test Preparation (Set Up)</h4>
        <a type="button" class="close text-white mr-1" (click)="modal.close()">
          <span style="color: black;" aria-hidden="true">&times;</span>
        </a>
      </div>
      <div class="modal-body m-2">
<h5 class="font-weight-bold">Purpose:</h5>
    <ul class="ml-5 mb-2" style="font-size: medium;">
        <li>Perform preliminary tasks before the main test.</li>
</ul>
<h5 class="font-weight-bold">Tasks:</h5>
    <ul class="ml-5 mb-2" style="font-size: medium;">
        <li><b>Database operations: </b>Create users, retrieve or populate data.</li>
        <li><b>Data manipulation: </b>Use JavaScript for data extraction or saving.</li>
</ul>
<h5 class="font-weight-bold">Example:</h5>
<ul class="ml-5 mb-2" style="font-size: medium;">
<li>Generating tokens, preparing test data, logging in users.</li>
</ul>
</div>
</div>
<div *ngIf="threadGroupType === 'TEAR_DOWN'">
    <div class="modal-header">
        <h4 class="modal-title" id="modal-title" style="margin-left: 10px;">Post-test Action (Tear Down)</h4>
        <a type="button" class="close text-white mr-1" (click)="modal.close()">
          <span style="color: black;" aria-hidden="true">&times;</span>
        </a>
      </div>
      <div class="modal-body m-2">
<h5 class="font-weight-bold">Purpose:</h5>
    <ul class="ml-5 mb-2" style="font-size: medium;">
        <li>Perform actions after completion of the main test.</li>
</ul>
<h5 class="font-weight-bold">Tasks:</h5>
    <ul class="ml-5 mb-2" style="font-size: medium;">
        <li><b>Reset application data: </b>Restore original state, delete test data.</li>
</ul>
<h5 class="font-weight-bold">Example:</h5>
<ul class="ml-5 mb-2" style="font-size: medium;">
<li>Resetting data created during test execution.</li>
</ul>
</div>
</div>

<div class="text-right mr-5 mb-4">
        <a class="btn btn-primary btn-sm mr-3" role="button" target="_blank" aria-disabled="true" href="https://relay.corp.adobe.com/#relay/testcase/222819" >Sample Scenarios</a>
        <a class="btn btn-info btn-sm" role="button" target="_blank" aria-disabled="true" href="https://wiki.corp.adobe.com/display/Relay/Support+for+Different+types+of+Thread+Groups">Detailed Wiki</a>
</div>
